module.exports = __webpack_public_path__ + "static/media/warmAl.0aa6314c.png";